<template>
    <q-page class="q-pa-md">
        <processed_files ref="processed_files"></processed_files>
    </q-page>
</template>

<script>
    export { default } from './processedfilesapplicationviewmodel-custom-screen.js'
</script>